export class User {
  id: number;
  name: string;
  email: string;
  email_verified_at: string;
  created_at: string;
  updated_at: string;
  security_level: number;
  deleted_at: string;
  password: string;
}

export interface UserExtraLayer{
  id: number;
  name: string;
  url: string;
}

const SecurityLevelLabel = {
  1: 'Resgistrado',
  2: 'Admin'
};
